import { Link } from "react-router-dom"
import LogoWhite from "../assets/LogoWhite.svg"

function Footer() {
  return (
    <div className='footer'>
        <div className="footer-head">
            <div className="footer-head-left">
                <h3>Get started to grow your businesss</h3>
                <p>Create an account and start getting Payments</p>
            </div>
            <div className="footer-head-right">
            <Link className="header-signup-btn hero-btn" to='/signup'>Create Acouunt</Link>
            </div>
            </div>
            <hr />
            <img className="logoWhite" src={LogoWhite} alt="logo" />
            <div className="footer-links">
                <div className="product">
                    <h5>Product</h5>
                    <p>Payment Links</p>
                    <p>Book-Keeping</p>
                </div>
                <div className="company">
                    <h5>Company</h5>
                    <Link className="footer-link" to="/"> About Us</Link>
                    <Link className="footer-link" to="/"> Careers</Link>
                </div>
                <div className="legal">
                    <h5>Legal</h5>
                    <p>Privacy</p>
                    <p>Terms & Conditions</p>
                </div>
                <div className="Contact">
                    <h5>Contact</h5>
                    <Link className="footer-contact-link" to="/"> hello@payourl.com</Link>
                </div>
            </div>
        </div>
  )
}

export default Footer